import axios from 'axios';
import { useEffect } from 'react'
import { useParams } from 'react-router-dom';

function ShashiUnpluggedOpen() {
  const { token } = useParams();

  useEffect(() => {
    if(token) window.location.href = `ShashiApp://?message=${encodeURIComponent(token)}`;
  }, [])

  return (
    <div>
      {/* {token} */}
    </div>
  )
}

export default ShashiUnpluggedOpen
